import styled from "@emotion/styled";
import * as React from "react";

import { chooseThemeVariant } from "../ThemeContext";
import BaseButton from "./BaseButton";

const StyledButton = styled(BaseButton)<{ iconOnly: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: ${(props) => (props.iconOnly ? "4px" : "4px 8px")};
  border-radius: 4px;
  background: ${chooseThemeVariant({
    translucent: "rgba(255, 255, 255, 0.8)",
    default: "#254CDD",
  })};
  color: ${chooseThemeVariant({
    translucent: "#254CDD",
    default: "#fff",
  })};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  outline: none;

  &:hover,
  &:focus-visible {
    background: ${chooseThemeVariant({
      translucent: "rgba(255, 255, 255, 0.96)",
      default: "#1034B8",
    })};
    color: ${chooseThemeVariant({
      translucent: "#1034B8",
      default: "#fff",
    })};
  }

  &:active {
    background: ${chooseThemeVariant({
      translucent: "rgba(255, 255, 255, 0.96)",
      default: "#212122",
    })};
  }

  &:disabled {
    opacity: ${chooseThemeVariant({
      translucent: 0.5,
      default: 1,
    })};
    color: ${chooseThemeVariant({
      translucent: "#254CDD",
      default: "rgba(255, 255, 255, 0.64)",
    })};
  }
`;

interface MinimalButtonProps extends React.ComponentProps<typeof BaseButton> {
  icon?: React.ReactNode;
}

const MinimalButton = ({
  icon,
  children,
  ...buttonProps
}: MinimalButtonProps) => {
  const iconOnly = !children;

  return (
    <StyledButton iconOnly={iconOnly} {...buttonProps}>
      {icon}

      {children}
    </StyledButton>
  );
};

export default MinimalButton;
